import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { TYRETEAM_CHANNELS, VehicleTyreReplacement } from "models";

type TyreTeamOrderPayload = {
  appointment_id: number;
  system_number: string;
  quantity: number;
  delivery: string;
  channel: TYRETEAM_CHANNELS;
  ref4?: string;
  ref5?: string;
  ref6?: string;
};

const isNotOrderedYet = (replacement: VehicleTyreReplacement, order: TyreTeamOrderPayload) =>
  !replacement.order_placed &&
  replacement.tyre_team_system_number === order.system_number &&
  replacement.tyre_team_channel === order.channel &&
  replacement.delivery_method === order.delivery;

export const useOrderTyreTeamMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: TyreTeamOrderPayload) => ApiInstance.post("/catalog/order", payload, ENV.tyreTeamBaseURLV2),
    onSuccess: payload => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.car?.tyres?.length || appointment.id !== payload.appointment_id) return;

      let quantityOrdered = payload.quantity;
      const tyres = appointment.car.tyres.map(tyre =>
        quantityOrdered > 0 && tyre.replacements?.some(r => isNotOrderedYet(r, payload))
          ? {
              ...tyre,
              replacements: tyre.replacements.map(replacement => {
                if (isNotOrderedYet(replacement, payload)) {
                  quantityOrdered--;
                  return { ...replacement, order_placed: true };
                }

                return replacement;
              })
            }
          : tyre
      );

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, car: { ...appointment.car, tyres } });
    }
  });
